import React from 'react';

import BasePopup from '@r1-frontend/ui-react/components/popups/basePopup';

import * as ST from './styled';

export interface IElementInfoProps {
    className?: string,
    title: string,
    displayImage: string,
    images: string[] | null,
    description: string,
    isOpen: boolean,
    onClose: () => void,
}

const ElementInfo: React.FC<IElementInfoProps> = ({
    className,
    title,
    displayImage,
    images,
    description,
    isOpen,
    onClose,
}): JSX.Element => {
    return (
        <BasePopup
            title={title}
            className={className}
            isOpen={isOpen}
            onClose={onClose}
            fullWidth={true}
            height='auto'
            customScrollBarStyles={{ view: { position: 'relative' } }}
            customDefaultPopupStyles={{
                popup: {
                    mobile: { width: '343px !important' },
                    default: {},
                },
            }}
            data-test='element-info-popup'
        >
            <ST.SEquipPreview
                data-test='element-info-preview'
                displayImage={displayImage}
                description={description}
                images={images}
                withDescTitle={false}
            />
        </BasePopup>
    );
};

export default React.memo(ElementInfo);
